export default __webpack_public_path__ + "static/O0215-30b6097d8b2b943f251767b5b7fade60.png";